import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useHistory } from 'react-router-dom';
import { useOverlayContext } from 'seagull/components/OverlayContext';
import { routes } from '~/constants';
import { useIoContext } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { BusinessChannelEventBinder } from '~/pusher/BusinessChannelEventBinder';
import { PusherEvent } from '~/pusher/model';
import { selectors } from '~/store/state-selectors';
import { useStore, useStoreActions } from '~/store/store-context';
import { IntegrationStatus } from '~/types/api.model';
import XeroLogo from '../../assets/XeroLogo';
import IntegrationCard from '../IntegrationCard/IntegrationCard';
const connectionInProgressCardProps = (param)=>{
    let { texts } = param;
    return {
        subTitle: texts.setupSubTitle(),
        mainAction: /*#__PURE__*/ _jsx(IntegrationCard.MainActionButton, {
            bi: {
                name: 'xero_connection_in_progress'
            },
            loading: true,
            loadingText: texts.connectionInProgress(),
            testId: "xero-card-connection-in-progress",
            children: texts.connectionInProgress()
        })
    };
};
const connectCardProps = (param)=>{
    let { handleConnect, texts } = param;
    return {
        subTitle: texts.connectSubTitle(),
        mainAction: /*#__PURE__*/ _jsx(IntegrationCard.MainActionButton, {
            bi: {
                name: 'connect_xero'
            },
            testId: "xero-card-connect-button",
            onClick: handleConnect,
            children: texts.connect()
        })
    };
};
const manageCardProps = (param)=>{
    let { companyName, handleManage, texts } = param;
    return {
        subTitle: texts.manageSubTitle({
            companyName
        }),
        mainAction: /*#__PURE__*/ _jsx(IntegrationCard.MainActionButton, {
            bi: {
                name: 'manage_xero_connection'
            },
            testId: "xero-card-manage-button",
            onClick: handleManage,
            children: texts.manageConnection()
        })
    };
};
export default function XeroCard() {
    const { t: texts } = useLocaleKeys('integrations.xero');
    const { startLoader, stopLoader } = useOverlayContext();
    const { changeLocation } = useIoContext();
    const { api, fetchIntegrations, logBI } = useStoreActions();
    const history = useHistory();
    const xeroIntegrationInStore = useStore(selectors.integration.xeroIntegration);
    if (!xeroIntegrationInStore) {
        return null;
    }
    const handleConnect = async ()=>{
        logBI(18600);
        startLoader();
        const integration = await api.xero.connect({
            redirectUrl: "http://".concat(window.location.host).concat(routes.availableApps)
        });
        if (integration.linkUrl) {
            const connectUrl = new URL(integration.linkUrl);
            changeLocation(connectUrl.toString());
        } else {
            stopLoader();
        }
    };
    const handleManage = async ()=>{
        logBI(18601);
        history.push(routes.xeroSetup);
    };
    function onPusherIntegrationEvent() {
        fetchIntegrations();
    }
    const integrationCardProps = ()=>{
        switch(xeroIntegrationInStore.status){
            case IntegrationStatus.Linked:
                {
                    return xeroIntegrationInStore.isReady() ? manageCardProps({
                        companyName: xeroIntegrationInStore.companyName() || 'your account',
                        handleManage: handleManage,
                        texts
                    }) : connectionInProgressCardProps({
                        texts
                    });
                }
            case IntegrationStatus.Unlinked:
                {
                    return connectCardProps({
                        handleConnect,
                        texts
                    });
                }
            default:
                {
                    return connectCardProps({
                        handleConnect,
                        texts
                    });
                }
        }
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(BusinessChannelEventBinder, {
                source: "mgmt",
                eventName: PusherEvent.IntegrationEvent,
                callback: onPusherIntegrationEvent
            }),
            /*#__PURE__*/ _jsx(IntegrationCard, _object_spread({
                testId: "xero-card",
                icon: /*#__PURE__*/ _jsx(XeroLogo, {}),
                title: texts.title()
            }, integrationCardProps()))
        ]
    });
}
